import ClientScript from "./implementations/clientScript.service";

export default defineNuxtPlugin((nuxtApp) => {
  const clientScript = new ClientScript(
    nuxtApp.$axios,
    nuxtApp.$config.public.sgCmsApi
  );

  return {
    provide: {
      clientScript: clientScript,
    },
  };
});
